import React from "react";
import DeleteModal from "../../../../components/DeleteModal";

const images = require.context("../../../../assests/images", true);

const FavoriteIcon = ({ className }) => (
  <svg
    className={className}
    width="30"
    height="30"
    viewBox="0 0 35 35"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M17.5 25.9143L26.5125 31.3538L24.1208 21.1018L32.0833 14.2038L21.5979 13.3143L17.5 3.64551L13.402 13.3143L2.91663 14.2038L10.8791 21.1018L8.48746 31.3538L17.5 25.9143Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Renders the action icons for each event row and wires them
 * to the correct parent callbacks (delete vs. edit vs. add/clone).
 */
const RenderButtonsInEvents = (props) => {
  const {
    meetupId,
    container,
    type,
    recurring,
    addSelectedEvent,
    cloneCustomEvent,
    showDeleteEventModal,
    deleteSelEvent,
    showEditEventModal,
    editCustomEvent,
    favorite,
    onToggleFavorite,
  } = props;

  // ALWAYS open the modal by passing (id, isCustom:boolean)
    const onDeleteClick = () => {
        props.showDeleteEventModal(props.meetupId, props.recurring);
    };
  // For the edit icon: recurring events open the recurring-edit modal,
  // custom events call your custom-edit handler.
  const onEditClick = () => {
    if (recurring) {
      showEditEventModal(meetupId, true);
    } else {
      editCustomEvent(meetupId);
    }
  };

  // Render the "+" icon on the Add-Events tab
  const renderAddIcons = () => (
    <>
      <button
        className="btn p-0 event-item__action-icons"
        onClick={() => addSelectedEvent(meetupId)}
      >
        <img src={images("./img/events/plus.svg")} alt="Add event" />
      </button>
      <button
        className="btn p-0 event-item__action-icons"
        onClick={() => props.cloneCustomEvent()}
      >
        <img src={images("./img/events/clone.svg")} alt="Create custom event" />
      </button>
    </>
  );

  // Render the Delete (and Edit, if custom) icons on My Schedule
  const renderMyScheduleIcons = () => (
    <div className="d-flex align-items-center justify-content-center">
      <label
        className={`favorite-toggle favorite-toggle--icon ${favorite ? "is-favorite" : ""}`}
        title={favorite ? "Unset favorite" : "Set favorite"}
      >
        <input
          className="favorite-toggle__input"
          type="checkbox"
          checked={!!favorite}
          aria-label={favorite ? "Unset favorite" : "Set favorite"}
          onChange={(event) => {
            if (typeof onToggleFavorite === "function") {
              onToggleFavorite(meetupId, event.target.checked);
            }
          }}
        />
        <FavoriteIcon className="favorite-toggle__icon" />
      </label>
      <button
        className="btn p-0 event-item__action-icons"
        onClick={onDeleteClick}
      >
        <img src={images("./img/events/remove.svg")} alt="Delete event" />
      </button>

      {type === "custom" && (
        <button
          className="btn p-0 event-item__action-icons"
          onClick={onEditClick}
        >
          <img src={images("./img/events/more.svg")} alt="Edit event" />
        </button>
      )}
    </div>
  );

  return (
    <div className="col-1 d-flex align-items-center justify-content-center">
      {container === "myevents"
        ? renderMyScheduleIcons()
        : renderAddIcons()}
    </div>
  );
};

export default RenderButtonsInEvents;
